import api from "../../config/client.axios.api";

export const createSolutionApi = async (infoCreate: any) => {
  const response = await api.post(`/solution`, infoCreate);
  return response.data;
};
